export enum ContentTypes {
  Json = 'application/json',
}

export enum Header {
  ContentType = 'Content-Type',
  Placement = 'x-placement',
}

export enum RequestMethod {
  Get = 'GET',
  Post = 'POST',
}

export enum RequestUrl {
  AcceptNotification = '/system/ajax/Message/AcceptFailMessage',
  AddBackorderDemand = '/system/ajax/ShoppingBag/AddBackorderDemand',
  AddBasketOffer = '/system/ajax/Offer/ApplyBasketOffer',
  AddCatalogueOffer = '/system/ajax/Offer/ApplyCatalogueOffer',
  AddCustomerOrder = '/system/ajax/EndConsumerOrder/ApproveOrders',
  AddFreeShippingOffer = '/system/ajax/Delivery/AddFreeShippingItem',
  AddToBasketCheckLoyalty = '/system/ajax/ShoppingBag/AddToShoppingBagItemAndCheckLoyalty',
  AddToBasketForMoney = '/system/ajax/ShoppingBag/AddOrUpdateShoppingBagItem',
  AddToBasketForPoints = '/system/ajax/Offer/AddOfferItem',
  AddToBasketForPointsRewardShop = '/system/ajax/Offer/RedeemLoyaltyPoints',
  AddVoucher = '/system/ajax/ShoppingBag/AddVoucher',
  CancelBackorderDemand = '/system/ajax/ShoppingBag/CancelBackorderDemand',
  CancelSubscription = '/system/ajax/ShoppingBag/CancelSubscription',
  ClearBasket = '/system/ajax/ShoppingBag/RemoveAllShoppingBagItems',
  DelaySubscription = '/system/ajax/ShoppingBag/DelaySubscription',
  GetShoppingContext = '/system/ajax/ShoppingBag/GetShoppingContext',
  PurchaseBasketOffer = '/system/ajax/Offer/PurchaseBasketOffer',
  RemoveBasketItem = '/system/ajax/ShoppingBag/RemoveShoppingBagItem',
  RemoveCustomerOrder = '/system/ajax/EndConsumerOrder/UnapproveOrder',
  RemoveVoucher = '/system/ajax/ShoppingBag/RemoveVoucher',
  ReplaceShoppingBagItem = '/system/ajax/ShoppingBag/ReplaceShoppingBagItem',
  ResetFreeShippingSelection = '/system/ajax/Delivery/ResetFreeShippingSelection',
  UpdateBasketItem = '/system/ajax/ShoppingBag/UpdateShoppingBagItem',
  UpdateCustomerOrderItem = '/system/ajax/EndConsumerOrder/UpdateEndConsumerOrderItem',
  UpdateDeliveryAddress = '/system/ajax/DeliverySelection/UpdateDeliveryAddress',
  UpdateDeliveryChannel = '/system/ajax/DeliverySelection/UpdateDeliveryChannel',
  UpdateDonation = '/system/ajax/Donation/UpdateDonation',
  UpdateOfferItem = '/system/ajax/Offer/UpdateOfferItem',
  UpdateOfferItems = '/system/ajax/Offer/UpdateOfferItems',
  UpdatePaymentProvider = '/system/ajax/Payment/UpdatePaymentProvider',
}
